var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 0, '\'', '.');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

function defineCustomElement(name, constructor) {
    if (!customElements.get(name)) {
        customElements.define(name, constructor);
    }
}

function parseInteger(value) {
    var parsedValue = parseInt(value, 10);

    if (Number.isNaN(parsedValue)) {
        return null;
    }

    return parsedValue;
}


// Product quantity picker
class ProductQuantityPicker extends HTMLElement {
    constructor() {
        super();
        this.onInteraction = this.onInteraction.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.addEventListener('click', this.onInteraction);
        this.addEventListener('keypress', this.onInteraction);
        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        this.removeEventListener('click', this.onInteraction);
        this.removeEventListener('keypress', this.onInteraction);
        this.isBound = false;
    }

    onInteraction(event) {
        var qualityCounter = event.target.closest('.qty-minus, .qty-plus');
        var isKeypressValid = event.type === 'keypress' && event.key === 'Enter';

        if (!qualityCounter || !this.contains(qualityCounter)) {
            return;
        }

        if (!(event.type === 'click' || isKeypressValid)) {
            return;
        }

        var qtyInput = this.querySelector('input');
        if (!qtyInput) {
            return;
        }

        var qtyInputValue = Number(qtyInput.value) || 0;
        var qtyInputMin = parseInteger(qtyInput.getAttribute('min'));
        var qtyInputMax = parseInteger(qtyInput.getAttribute('max'));

        if (qualityCounter.classList.contains('qty-minus')) {
            if (qtyInputMin === null || qtyInputMin < qtyInputValue) {
                qtyInputValue--;
            }
        }

        if (qualityCounter.classList.contains('qty-plus')) {
            if (qtyInputMax === null || qtyInputMax > qtyInputValue) {
                qtyInputValue++;
            }
        }

        qtyInput.value = qtyInputValue;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

defineCustomElement('product-quantity-picker', ProductQuantityPicker);


// Search Dropdown
class SearchDropdown extends HTMLElement {
    constructor() {
        super();
        this.onToggleClick = this.onToggleClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.dropdownToggle = this.querySelector('.search-dropdown-toggle');
        this.searchField = this.querySelector('input[type="search"]');
        this.dropdownClose = this.querySelector('.search-dropdown-close');

        if (this.dropdownToggle) {
            this.dropdownToggle.addEventListener('click', this.onToggleClick);
        }

        if (this.dropdownClose) {
            this.dropdownClose.addEventListener('click', this.onCloseClick);
        }

        document.addEventListener('click', this.onDocumentClick);
        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        if (this.dropdownToggle) {
            this.dropdownToggle.removeEventListener('click', this.onToggleClick);
        }

        if (this.dropdownClose) {
            this.dropdownClose.removeEventListener('click', this.onCloseClick);
        }

        document.removeEventListener('click', this.onDocumentClick);
        this.isBound = false;
    }

    onToggleClick(event) {
        event.preventDefault();

        if (!this.classList.contains('active')) {
            this.open();
        }
        else {
            this.close();
        }
    }

    onCloseClick() {
        this.close();
    }

    onDocumentClick(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }

    open() {
        this.classList.add('active');

        window.setTimeout(() => {
            if (this.searchField) {
                this.searchField.focus();
            }
        }, 100);
    }

    close() {
        this.classList.remove('active');
    }
}

defineCustomElement('search-dropdown', SearchDropdown);


// Carousel
function getCarouselElements(root) {
    var elements = [];

    if (!root) {
        return elements;
    }

    if (root.matches && root.matches('.has-carousel')) {
        elements.push(root);
    }

    return elements.concat(Array.from(root.querySelectorAll('.has-carousel')));
}

function mountCarousels(root) {
    getCarouselElements(root || document).forEach(function (carouselElement) {
        if (carouselElement.dataset.carouselMounted === 'true') {
            return;
        }

        var carouselOptions = {};

        if (carouselElement.dataset.options) {
            try {
                carouselOptions = JSON.parse(carouselElement.dataset.options);
            } catch (error) {
                console.error(error);
                return;
            }
        }

        carouselOptions.classes = {
            arrows: 'splide__arrows',
            arrow: 'splide__arrow',
            prev: 'splide__arrow--prev',
            next: 'splide__arrow--next'
        };

        carouselElement.dataset.carouselMounted = 'true';

        var splide = new Splide(carouselElement, carouselOptions);
        splide.mount();
    });
}

mountCarousels(document);


// Popup modal
class PopupModal extends HTMLElement {
    constructor() {
        super();
        this.onClose = this.onClose.bind(this);
        this.onSectionCloseClick = this.onSectionCloseClick.bind(this);
        this.isBound = false;
        this.onloadTimeout = null;
        this.hasHandledOnloadPopup = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.popupCloseButton = this.querySelector('.popup-modal__close');
        this.popupOverlay = this.querySelector('.popup-modal__overlay');
        this.popupContent = this.querySelector('.popup-modal__content');
        this.sectionPopupClose = this.querySelector('.section-popup-button-close');

        if (this.popupCloseButton) {
            this.popupCloseButton.addEventListener('click', this.onClose);
        }

        if (this.popupOverlay) {
            this.popupOverlay.addEventListener('click', this.onClose);
        }

        if (this.sectionPopupClose) {
            this.sectionPopupClose.addEventListener('click', this.onSectionCloseClick);
        }

        if (this.dataset.popupType === 'onload' && !this.hasHandledOnloadPopup) {
            this.handleOnLoadPopup();
            this.hasHandledOnloadPopup = true;
        }

        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        if (this.popupCloseButton) {
            this.popupCloseButton.removeEventListener('click', this.onClose);
        }

        if (this.popupOverlay) {
            this.popupOverlay.removeEventListener('click', this.onClose);
        }

        if (this.sectionPopupClose) {
            this.sectionPopupClose.removeEventListener('click', this.onSectionCloseClick);
        }

        if (this.onloadTimeout) {
            clearTimeout(this.onloadTimeout);
            this.onloadTimeout = null;
        }

        this.isBound = false;
    }

    onSectionCloseClick(event) {
        event.preventDefault();
        this.onClose();
    }

    onClose() {
        this.classList.add('inactive');
        this.classList.remove('quickview-modal');

        if (this.popupContent) {
            this.popupContent.innerHTML = '';
        }
    }

    handleOnLoadPopup() {
        this.style.display = null;

        var expireOn = parseInteger(this.dataset.popupExpiry);
        var delay = parseInteger(this.dataset.popupDelay) || 0;
        var cookieName = this.dataset.popupCookieName;
        var frequency = 1;

        if (!cookieName) {
            return;
        }

        var visits = parseInteger(Cookies.get(cookieName)) || 0;
        visits++;

        Cookies.set(cookieName, visits, { expires: expireOn || 1, path: '/' });

        if (visits > frequency) {
            this.onClose();
            return;
        }

        this.onloadTimeout = window.setTimeout(() => {
            this.classList.remove('inactive');
        }, delay);
    }
}

defineCustomElement('popup-modal', PopupModal);

// Quickview
document.addEventListener('click', (e) => {
    var productQuickview = e.target.closest('.product-quickview');

    if (!productQuickview) {
        return;
    }

    var handle = productQuickview.dataset.handle;
    if (!handle) {
        return;
    }

    productQuickview.classList.add('loading');

    var popupModal = document.querySelector('.popup-modal');

    if (!popupModal) {
        var quickviewModalString = `<popup-modal class="popup-modal">
            <div class="popup-modal__overlay"></div>
            <div class="popup-modal__inner">
                <div class="popup-modal__content">
                </div>
                <button class="popup-modal__close">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="#171813" stroke-linecap="round"/>
                        <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="#171813" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
            </popup-modal>
                          `
        var quickviewModal = new DOMParser().parseFromString(quickviewModalString, 'text/html').querySelector('popup-modal');

        document.body.append(quickviewModal);
        popupModal = quickviewModal;
        popupModal.classList.add('quickview-modal');
    }
    else {
        popupModal.classList.remove('inactive');
        popupModal.classList.remove('section-popup');
        popupModal.classList.add('quickview-modal');
    }

    fetch(`${window.Shopify.routes.root}products/${handle}?view=quickview`)
        .then((response) => {
            if (!response.ok) {
                throw new Error(response.status);
            }

            return response.text();
        })
        .then((res) => {
            productQuickview.classList.remove('loading');

            var html = new DOMParser().parseFromString(res, 'text/html').querySelector('.main-product');
            if (!html) {
                return;
            }

            html.classList.add('quickview-product');
            html.classList.remove('main-product');

            var productInfoButtons = html.querySelectorAll('.product-info-popup__button');
            for (let productInfoButton of productInfoButtons) {
                productInfoButton.setAttribute('target', '_blank');
            }

            var popupModalContent = popupModal.querySelector('.popup-modal__content');
            if (!popupModalContent) {
                return;
            }

            popupModalContent.append(html);
            mountCarousels(popupModalContent);

            if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }
        })
        .catch((error) => {
            productQuickview.classList.remove('loading');
            console.error(error);
        });
});


// Shoppable Pins 

class ShoppablePins extends HTMLElement {
    constructor() {
        super();
        this.onPinClick = this.onPinClick.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.product = this.querySelector('.section-image-pins-list-item-product');
        this.pin = this.querySelector('.section-image-pins-list-item-pin');

        if (this.pin) {
            this.pin.addEventListener('click', this.onPinClick);
        }

        document.addEventListener('click', this.onDocumentClick);
        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        if (this.pin) {
            this.pin.removeEventListener('click', this.onPinClick);
        }

        document.removeEventListener('click', this.onDocumentClick);
        this.isBound = false;
    }

    onPinClick(event) {
        this.classList.contains('active') ? this.close() : this.open(event);
    }

    onDocumentClick(event) {
        if (!this.contains(event.target)) {
            this.close();
        }
    }

    open(event) {
        if (!this.product) {
            return;
        }

        this.product.style.display = 'block';

        var panelHeight = this.product.offsetHeight;
        var panelWidth = this.product.offsetWidth;
        var x = event.clientX,
            y = event.clientY;


        if ((window.innerHeight - y) > panelHeight) {
            this.product.classList.add('place-below');
        }
        else if (y > panelHeight) {
            this.product.classList.add('place-above');
        }
        else {
            this.product.classList.add('place-center');
        }


        if ((window.innerWidth - x) > panelWidth) {
            this.product.classList.add('place-right');
        }
        else if (x > panelWidth) {
            this.product.classList.add('place-left');
        }
        else {
            this.product.classList.add('place-center');
        }

        setTimeout(() => {
            this.classList.add('active')
        }, 50);
        // this.classList.add('active');

    }

    close() {
        if (!this.product) {
            return;
        }

        this.classList.remove('active');


        setTimeout(() => {
            this.product.classList.remove('place-above', 'place-below', 'place-center', 'place-left', 'place-right');
            this.product.style.display = 'none';
        }, 300);
    }

}
defineCustomElement('shoppable-pin', ShoppablePins)



function AjaxProductUpdate(product, data) {

    var cartCountElements = document.querySelectorAll('.cart-count');
    var cartDrawerSelector = '.cart-drawer-inner';

    // Count update
    for (let cart_count of cartCountElements) {
        var totalCount = parseInt(data['quantity']);

        if (cart_count.textContent) {
            totalCount = parseInt(cart_count.textContent) + parseInt(data['quantity'])
        }

        cart_count.textContent = totalCount
        // cart_count.textContent = product.item_count
    }

    // Drawer update
    var cartDrawer = product.sections['cart-drawer'];
    var cartDrawerInnerDOM = new DOMParser().parseFromString(cartDrawer, 'text/html').querySelector(cartDrawerSelector);

    var cartDrawerInner = document.querySelector('.cart-drawer-inner');
    if (cartDrawerInner) {
        cartDrawerInner.replaceWith(cartDrawerInnerDOM);
    }

}

function getThemeString(key, fallback) {
    var body = document.body;

    if (!body) {
        return fallback || '';
    }

    var datasetKey = '';

    switch (key) {
        case 'productUnavailable':
            datasetKey = 'productUnavailableText';
            break;
        case 'validEmailAddress':
            datasetKey = 'validEmailAddressText';
            break;
        case 'validDateRange':
            datasetKey = 'validDateRangeText';
            break;
    }

    if (datasetKey && typeof body.dataset[datasetKey] === 'string' && body.dataset[datasetKey].length > 0) {
        return body.dataset[datasetKey];
    }

    return fallback || '';
}


// Product quick add and add to cart Ajax
document.body.addEventListener('click', event => {

    let quickAddSelector = '.product__quick-add';
    let quickAddButton = event.target.closest(quickAddSelector);

    if (quickAddButton && !quickAddButton.hasAttribute('disabled')) {
        event.preventDefault();

        let variantId = quickAddButton.dataset.variantId;
        if (!variantId) return;

        let cartDrawerSelector = 'cart-drawer';

        let formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append('sections', cartDrawerSelector);

        fetch(`${window.Shopify.routes.root}cart/add`, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            body: formData
        })
            .then(response => response.json())
            .then(res => {
                if (res.status == 422) {
                    if (window.alert) {
                        window.alert(res.description || getThemeString('productUnavailable'));
                    }
                    return false;
                }

                AjaxProductUpdate(res, { quantity: 1 });

                let cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.open();
                }

                let popupModal = document.querySelector('popup-modal');
                if (popupModal) {
                    popupModal.classList.add('inactive');
                    popupModal.querySelector('.popup-modal__content').innerHTML = '';
                }
            })
            .catch((error) => {
                console.error(error);
            });

        return;
    }

    let productAddToCartSelector = '.product-add-to-cart';
    let productAddToCart = event.target.closest(productAddToCartSelector);

    if (productAddToCart && !productAddToCart.hasAttribute('disabled')) {
        event.preventDefault();

        let cartDrawerSelector = 'cart-drawer';
        let addToCartForm = productAddToCart.closest('form');

        if (!addToCartForm) {
            return;
        }

        let productSummary = productAddToCart.closest('.product-summary');
        if (!productSummary) {
            return;
        }

        let productSummaryTitle = productSummary.querySelector('.product-summary__title');
        let productSummaryAction = productSummary.querySelector('.product-summary__action');
        let productQty = addToCartForm.querySelector('input[name="quantity"]');

        let formData = new FormData(addToCartForm);
        let data = Object.fromEntries(formData.entries());
        let requestedQuantity = parseInteger(data['quantity']);

        if (requestedQuantity === null || requestedQuantity < 1) {
            requestedQuantity = 1;
            formData.set('quantity', requestedQuantity);
            data['quantity'] = String(requestedQuantity);
        }

        formData.append(
            'sections',
            cartDrawerSelector
        );

        let quantityMax = productQty ? parseInteger(productQty.getAttribute('max')) : null;

        if (quantityMax !== null && requestedQuantity > quantityMax) {

            let productSelect = addToCartForm.querySelector('select');
            let currentErrorParagraph = productSummaryAction ? productSummaryAction.querySelector('.error') : null;
            let selectedOptionText = '';

            if (productSelect && productSelect.selectedIndex >= 0) {
                selectedOptionText = productSelect.options[productSelect.selectedIndex].textContent.trim();
            }

            let errorText = productAddToCart.dataset.textQtyError.replace(
                '%qty',
                quantityMax + ' ' + (productSummaryTitle ? productSummaryTitle.innerText : '') + (selectedOptionText ? ' - ' + selectedOptionText : '')
            );

            if (currentErrorParagraph) {
                currentErrorParagraph.innerHTML = errorText;
            } else if (productSummaryAction) {
                let errorParagraph = document.createElement('p');
                errorParagraph.classList.add('error');
                errorParagraph.innerHTML = errorText;
                productSummaryAction.prepend(errorParagraph);
            }

            return false;
        }

        var recipientForm = productSummary.querySelector('.recipient-form');
        if (recipientForm) {
            var recipientFormErrors = recipientForm.querySelector('.recipient-form-errors');
            var isRecipientFormEnabled = productSummary.querySelector('.recipient-form-toggle input:checked') ? true : false;
            var recipientFormInputs = recipientForm.querySelectorAll('.recipient-form-fields--field');

            if (isRecipientFormEnabled) {
                var errors = [];
                recipientFormInputs.forEach(formInput => {
                    if (formInput.classList.contains('required')) {
                        if (formInput.getAttribute('type') == 'email') {
                            var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            var formInputValue = formInput.value;

                            if (!pattern.test(formInputValue)) {
                                errors.push(getThemeString('validEmailAddress'));

                            }
                        }
                    }
                    if (formInput.getAttribute('type') == 'date') {
                        var timeDiff = new Date(Date.parse(formInput.value)).getTime() - new Date().getTime();
                        var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

                        if (daysDiff < 0 || daysDiff > 90) {
                            errors.push(getThemeString('validDateRange'));
                        }

                    }
                });
                if (errors.length > 0) {
                    var errorElements = errors.map(function (element) {
                        return `<li>${element}</li>`;
                    });

                    recipientFormErrors.innerHTML = errorElements.join("");

                    return false;

                }
            }
        }


        fetch(`${window.Shopify.routes.root}cart/add`, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            body: formData
        })
            .then(response => response.json())
            .then(res => {
                if (res.status == 422) {
                    let currentErrorParagraph = productSummaryAction ? productSummaryAction.querySelector('.error') : null;

                    if (currentErrorParagraph) {
                        currentErrorParagraph.innerHTML = res.description;
                    } else if (productSummaryAction) {
                        let errorParagraph = document.createElement('p');
                        errorParagraph.classList.add('error');
                        errorParagraph.innerHTML = res.description;
                        productSummaryAction.prepend(errorParagraph);
                    }

                    return false;
                }

                let currentErrorParagraph = productSummaryAction ? productSummaryAction.querySelector('.error') : null;
                if (currentErrorParagraph) {
                    currentErrorParagraph.remove();
                }

                AjaxProductUpdate(res, data);

                let cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.open();
                }

                let popupModal = document.querySelector('popup-modal');
                if (popupModal) {
                    popupModal.classList.add('inactive');
                    popupModal.querySelector('.popup-modal__content').innerHTML = '';
                }
            })
            .catch((error) => {
                console.error(error);
            });


    }

});

class ProductVariantsSelectors extends HTMLElement {
    constructor() {
        super();
        this.onVariantInputChange = this.onVariantInputChange.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        var currentVariant = new URLSearchParams(window.location.search).get('variant');
        this.productVariantSelectors = Array.from(this.querySelectorAll('select'));

        this.productVariantSelectors.forEach((variant) => {
            if (currentVariant && variant.value === currentVariant) {
                this.onVariantChange(variant);
            }

            variant.addEventListener('change', this.onVariantInputChange);
        });

        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound || !this.productVariantSelectors) {
            return;
        }

        this.productVariantSelectors.forEach((variant) => {
            variant.removeEventListener('change', this.onVariantInputChange);
        });

        this.isBound = false;
    }

    onVariantInputChange(event) {
        this.onVariantChange(event.currentTarget);
    }

    onVariantChange = (productVariantSelector) => {
        const variantId = productVariantSelector.options[productVariantSelector.selectedIndex].value;
        var productRoot = productVariantSelector.closest('.product');
        if (!productRoot) {
            return;
        }

        var productAddtocartElement = productRoot.querySelector('.product-add-to-cart');
        var productQtyElement = productRoot.querySelector('.product-inventory-qty');
        var productPriceElement = productRoot.querySelector('.product-price');
        var moneyFormat = document.body.dataset.moneyFormat;

        if (variantId === 'none') {
            if (productAddtocartElement) {
                productAddtocartElement.disabled = true;
                productAddtocartElement.innerHTML = '<span>' + productAddtocartElement.dataset.textUnavailable + '</span>';
            }

            if (productQtyElement) {
                productQtyElement.innerHTML = '';
            }

            if (productPriceElement) {
                productPriceElement.classList.add('hide');
            }

            return;
        }

        if (productPriceElement) {
            productPriceElement.classList.remove('hide');
        }

        fetch(`${window.Shopify.routes.root}variants/${variantId}.json`)
            .then(response => response.json())
            .then(res => {
                const productVariant = res.product_variant;
                if (!productVariant) {
                    return;
                }

                const comparePriceValue = productVariant.compare_at_price;
                const priceValue = productVariant.price;
                const unitPriceValue = productVariant.unit_price;

                const comparePrice = Shopify.formatMoney(comparePriceValue, moneyFormat);
                const price = Shopify.formatMoney(priceValue, moneyFormat);
                const unitPrice = Shopify.formatMoney(unitPriceValue, moneyFormat);


                var priceElement = productRoot.querySelector('[data-price]');
                var comparePriceElement = productRoot.querySelector('[data-price-compare]');
                var unitPriceWrapperElement = productRoot.querySelector('.product-price-unit');

                var saleBadgeElement = productRoot.querySelector('.product-sale-badge');

                var productPriceText = productPriceElement ? productPriceElement.dataset.textSale : '';

                // Change price
                if (priceElement) {
                    priceElement.innerHTML = price;
                }

                if (comparePriceValue) {

                    // Add Sale badge if not exist
                    if (!saleBadgeElement && productPriceElement) {
                        var newSaleBadgeElement = document.createElement('span');
                        newSaleBadgeElement.classList.add('product-sale-badge');
                        newSaleBadgeElement.innerHTML = productPriceText;
                        productPriceElement.prepend(newSaleBadgeElement);
                    }

                    // Change compare price
                    if (comparePriceElement) {
                        comparePriceElement.innerHTML = comparePrice;
                    }
                }
                else {
                    // Remove sale badge if exist
                    if (saleBadgeElement) {
                        saleBadgeElement.remove();
                    }

                    // Remove compare price
                    if (comparePriceElement) {
                        comparePriceElement.innerHTML = '';
                    }
                }


                // Change unit price
                if (unitPriceValue) {

                    const refValue = productVariant.unit_price_measurement.reference_value
                    const refUnit = productVariant.unit_price_measurement.reference_unit

                    var unitPriceSelector = 'data-price-unit-price';
                    var unitBaseSelector = 'data-price-unit-base';

                    var unitPriceElement = productRoot.querySelector('[' + unitPriceSelector + ']');
                    var unitBaseElement = productRoot.querySelector('[' + unitBaseSelector + ']');

                    if (unitPriceWrapperElement) {
                        unitPriceElement.innerHTML = unitPrice;

                        // Change unit ref
                        unitBaseElement.innerHTML = (refValue > 1) ? refValue + refUnit : refUnit;
                    }
                    else {
                        var newUnitPriceWrapperElement = document.createElement('span');
                        var newUnitPriceElement = document.createElement('span');
                        var newUnitBaseElement = document.createElement('span');

                        newUnitPriceElement.setAttribute(unitPriceSelector, '')
                        newUnitBaseElement.setAttribute(unitBaseSelector, '')

                        newUnitPriceElement.innerHTML = unitPrice

                        // Change unit ref
                        newUnitBaseElement.innerHTML = (refValue > 1) ? refValue + refUnit : refUnit

                        newUnitPriceWrapperElement.classList.add('product-price-unit');
                        newUnitPriceWrapperElement.append(newUnitPriceElement);
                        newUnitPriceWrapperElement.append('/');
                        newUnitPriceWrapperElement.append(newUnitBaseElement);
                        if (productPriceElement) {
                            productPriceElement.append(newUnitPriceWrapperElement);
                        }

                    }
                }
                else {
                    // Remove unit price wrapper
                    if (unitPriceWrapperElement) {
                        unitPriceWrapperElement.remove();
                    }
                }

            })
            .catch(e => {
                console.error(e);
            });

        var productStockHtml = '';
        var productAddtocartHtml = '';
        var productQtyInput = productRoot.querySelector('.product-quantity-picker-input');
        var selectedOption = productVariantSelector.options[productVariantSelector.selectedIndex];
        var productStockQty = selectedOption.dataset.inventoryQuantity;
        var productStockManagement = selectedOption.dataset.inventoryManagement;
        var productStockPolicy = selectedOption.dataset.inventoryPolicy;

        if (productQtyInput) {
            if (productStockQty != 0 && productStockManagement != '') {
                productQtyInput.setAttribute('max', productStockQty);
            }
            else if (productStockManagement == '') {
                productQtyInput.removeAttribute('max');
            }
        }

        if (productQtyElement) {
            if (productStockQty != 0) {
                var lowStockThreshold = productQtyElement.dataset.lowStockThreshold;

                if (lowStockThreshold >= productStockQty) {
                    productStockHtml = '<p class="low">' + productQtyElement.dataset.textLowStock.replace('%s', productStockQty) + '</p>'
                }
                else if (productStockManagement != '' && productStockPolicy != 'continue') {
                    productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStock.replace('%s', productStockQty) + '</p>'
                }
                else {
                    productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStockNoTrack + '</p>'
                }

            }
            else if (productStockQty == 0 && productStockManagement == '') {
                productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStockNoTrack + '</p>'
            }
            else {
                productStockHtml = '<p class="sold">' + productQtyElement.dataset.textSold.replace('%s', productStockQty) + '</p>'
            }

            productQtyElement.innerHTML = productStockHtml
        }


        if (productAddtocartElement) {
            if (productStockQty != 0 || productStockManagement == '') {
                productAddtocartHtml = '<span>' + productAddtocartElement.dataset.textAddToCart + '</span>';
                productAddtocartElement.disabled = false
            }
            else {
                productAddtocartHtml = '<span>' + productAddtocartElement.dataset.textSoldOut + '</span>'
                productAddtocartElement.disabled = true
            }
            productAddtocartElement.innerHTML = productAddtocartHtml
        }



        // Changing image
        var productThumbails = productRoot.querySelectorAll('.product-image-has-variant-ids')

        for (let thumbnail of productThumbails) {
            const imageVariantIds = thumbnail.dataset.variantIds
            if (imageVariantIds.includes(variantId)) {
                thumbnail.dispatchEvent(new Event('click'));
            }
        }

    }
}
defineCustomElement('product-variants-selector', ProductVariantsSelectors)

// Video player controls
var videoPlay = document.querySelectorAll('.video-play');

videoPlay.forEach(button => {
    button.addEventListener('click', function (e) {
        var player = button.closest('.video-player');
        var playerVideo = player.querySelector('video');
        var playerIframe = player.querySelector('iframe');

        if (playerVideo) {
            playerVideo.play();
        }

        if (playerIframe) {
            playerIframe.setAttribute('src', playerIframe.getAttribute('src') + '?autoplay=1')
        }

        player.classList.add('playing');

    })
})



// Collapsible row
class CollapsibleRow extends HTMLElement {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.isBound = false;
    }

    connectedCallback() {
        if (this.isBound) {
            return;
        }

        this.collapsibleTitle = this.querySelector('.collapsible-row__title');
        this.detectDefaultTab();

        if (this.collapsibleTitle) {
            this.collapsibleTitle.addEventListener('click', this.onClick);
        }

        this.isBound = true;
    }

    disconnectedCallback() {
        if (!this.isBound) {
            return;
        }

        if (this.collapsibleTitle) {
            this.collapsibleTitle.removeEventListener('click', this.onClick);
        }

        this.isBound = false;
    }

    detectDefaultTab = () => {
        if (this.classList.contains('active_by_default')) {
            var collapsibleContent = this.querySelector('.collapsible-row__content');
            if (!collapsibleContent) {
                return;
            }

            var collapsibleContentHeight = collapsibleContent.scrollHeight;
            collapsibleContent.style.height = collapsibleContentHeight + 'px';
            this.classList.remove('active_by_default');
        }
    }

    onClick = () => {
        var collapsibleContent = this.querySelector('.collapsible-row__content');
        if (!collapsibleContent) {
            return;
        }

        if (this.classList.contains('active')) {
            collapsibleContent.style.removeProperty('height');
            setTimeout(() => {
                this.classList.remove('active');
            }, 200)
        }
        else {
            this.classList.add('active');
            setTimeout(() => {
                collapsibleContent.style.height = collapsibleContent.scrollHeight + 'px';
            }, 10)
        }
    }

}
defineCustomElement('collapsible-row', CollapsibleRow)
